import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'pdf/:url',
  async getComponent (nextState) {
    const {
      default: PdfContainer
    } = await import(/* webpackChunkName: "pdf-container" */ './PdfContainer')
      .catch(handleChunkLoadError);
    return PdfContainer;
  },
  children: [{
    path: '',
    getData ({ context: { props } }) {
      return props;
    },
    async getComponent (nextState) {
      const {
        default: PdfRoot
      } = await import(/* webpackChunkName: "pdf-root" */ './PdfRoot')
        .catch(handleChunkLoadError);
      return PdfRoot;
    }
  }]
});
